import en from "./en";
import nl from "./nl";
const lang = {
  en: en(),
  nl: nl(),
};

export default function getLang(type = "en") {
  return lang[type];
}
